export default ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
    return {
        findSubmissionsByCreateUser: function findSubmissionsByCreateUser() {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionsByCreateUser', []);
        },

        findSubmissionByCreateUserOpenedWithinNumberOfDays: function findSubmissionByCreateUserOpenedWithinNumberOfDays(numberOfDays) {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionByCreateUserOpenedWithinNumberOfDays', [numberOfDays]);
        },

        findSubmissionsByAccount: function findSubmissionsByAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionsByAccount', [accountNumber]);
        },

        findJobByJobNumber: function findJobByJobNumber(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'findJobByJobNumber', [jobNumber]);
        },

        withdrawJobByJobNumber: function withdrawJobByJobNumber(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'withdrawJobByJobNumber', [jobNumber]);
        },
        getOpenJobsByJobTypeForCurrentUser: function getOpenJobsByJobTypeForCurrentUser(jobType) {
            return JsonRPCService.send('pc', 'gateway/submission', 'getOpenJobsByJobTypeForCurrentUser', [jobType]);
        },
        findSubmissionSummariesByAccount: function findSubmissionSummariesByAccount(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/submission', 'findSubmissionSummariesByAccount', [accountNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/JobService.js
// module id = 1787
// module chunks = 0